import React from "react";
import {ZellMitTooltip} from "./ZellTooltip.jsx";

/**
 * Ruhiges, eindeutiges Abzeichen für auslaufende Farbtöne (Freigabe
 * Thorsten 22.09.2026, Meeting-Fakt 4): Diese Farbtöne gibt es nur noch in
 * der alten Fassung, Cosmos produziert sie nicht mehr. Bewusst derselbe
 * neutrale Stil wie das bestehende Abzeichen "außerhalb Sortiment"
 * (LieferplanTabelle.jsx) statt einer Warnfarbe - kein Fehlerzustand,
 * sondern eine Sortimentstatsache.
 *
 * Rückmeldung Thorsten 23.09.2026: „Das Label soll von der Position her
 * nicht springen. Platziere es sehr klein rechts oben in der Zelle und
 * hinterlege die gesamte Zeile leicht, damit man den Unterschied deutlich
 * erkennt." Die feste Position vergibt deshalb die aufrufende Zelle
 * (position:absolute oben rechts); hier steht nur die kleine Darstellung.
 */
export default function AuslaufendAbzeichen() {
    return (
        <ZellMitTooltip text="Dieser Farbton existiert nur noch in der alten Fassung und wird bei Cosmos nicht mehr produziert. Keine Bestellvorschläge, kein Fehlbestand in der Zukunft.">
            <span
                className="badge text-bg-secondary"
                style={{fontSize: ".58rem", fontWeight: 600, padding: ".15em .4em", letterSpacing: ".02em"}}
            >
                läuft aus
            </span>
        </ZellMitTooltip>
    );
}
